import MetricBase from "models/metrics/MetricBase";
import PerformanceGroup from "models/groups/PerformanceGroup";
import EmptyUnit from "models/metrics/unit/EmptyUnit";
import i18n from "i18next";

class MetricClicksBing extends MetricBase {
    constructor() {
        super({
            field: "metric_clicks",
            defaultVisibility: true,
            unit: new EmptyUnit(),
            chartName: i18n.t("metrics.bing-hotel-ads.clicks.chartName"),
            serieLabel: i18n.t("metrics.bing-hotel-ads.clicks.serieLabel"),
            tooltip: i18n.t("metrics.bing-hotel-ads.clicks.tooltip"),
            group: new PerformanceGroup(),
        });
    }
}

export default MetricClicksBing;
